import ResetPassword from "@/src/screens/auth/reset-password-screen/reset-password-screen";

function SetPasswordRoute() {
  return <ResetPassword type="set-password" />;
}
export default SetPasswordRoute;
